document.addEventListener("DOMContentLoaded", function () {
    $('[data-init="toast"]').toast('show');

    const userId = Cookies.get("user_id");
    const domain = Cookies.get("domain");
    const path = Cookies.get("path");
    const currentDomain = window.location.hostname;
    const currentPath = window.location.pathname.split("/").slice(0, -1).join("/");

    // Check for 2FA token in localStorage - if it exists, we should be on the 2FA verification page
    const twofa_token = localStorage.getItem("twofa_token");

    // If on 2FA page with token, setup 2FA verification form handler
    if (twofa_token && window.location.pathname.includes("twofa_verify.php")) {
        setupTwoFAVerification(twofa_token);
        return; // Exit early, don't process the login form
    }

    // Handle auto redirect to dashboard if already logged in
    if (userId && domain === currentDomain && path === currentPath) {
        window.location.href = "dashboard.php";
    } else {
        Cookies.remove("user_id");
        Cookies.remove("username");
        Cookies.remove("name");
        Cookies.remove("avatar");
        Cookies.remove("domain");
        Cookies.remove("path");
        Cookies.remove("user_type");

        // Also clear any 2FA tokens when clearing cookies
        localStorage.removeItem("twofa_token");
    }

    // Handle login form submission
    const loginForm = document.forms.login_form;
    if (!loginForm) return;

    const redirectUrl = new URLSearchParams(window.location.search).get("redirect") || "dashboard.php";

    loginForm.addEventListener("submit", function (event) {
        event.preventDefault();

        const csrfToken = loginForm.querySelector('input[name="csrf_token"]')?.value;
        const username = loginForm.username.value;
        const password = loginForm.password.value;
        const formData = new FormData();

        if (!csrfToken) {
            showError("CSRF token missing. Please refresh the page.");
            return;
        }

        formData.append("csrf_token", csrfToken);
        formData.append("username", username);
        formData.append("password", password);
        formData.append("redirect", redirectUrl);

        const recaptchaElement = document.querySelector(".g-recaptcha");
        if (recaptchaElement) {
            const recaptchaResponse = grecaptcha.getResponse();
            if (!recaptchaResponse) {
                showError("Please complete the reCAPTCHA.");
                return;
            }
            formData.append("g-recaptcha-response", recaptchaResponse);
        }

        // Show loading state
        const submitButton = loginForm.querySelector('button[type="submit"]');
        const originalButtonText = submitButton.innerHTML;
        submitButton.disabled = true;
        submitButton.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Signing in...';

        fetch("./includes/login.php", {
            method: "POST",
            body: formData
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                // console.log("Login response:", data); // For debugging

                // Reset button state
                submitButton.disabled = false;
                submitButton.innerHTML = originalButtonText;

                if (data.success) {
                    // Regular login success
                    const expirationDate = new Date();
                    expirationDate.setTime(expirationDate.getTime() + (3 * 60 * 60 * 1000));
                    const newPath = window.location.pathname.split("/").slice(0, -1).join("/");

                    Cookies.set("user_id", data.user_id, { expires: expirationDate, path: "/" });
                    Cookies.set("username", data.username, { expires: expirationDate, path: "/" });
                    Cookies.set("name", data.name, { expires: expirationDate, path: "/" });
                    Cookies.set("avatar", data.avatar, { expires: expirationDate, path: "/" });
                    Cookies.set("domain", currentDomain, { expires: expirationDate, path: "/" });
                    Cookies.set("path", newPath, { expires: expirationDate, path: "/" });
                    Cookies.set("user_type", data.user_type, { expires: expirationDate, path: "/" });

                    window.location.href = redirectUrl;
                } else if (data.requires_2fa) {
                    // Got 2FA request with token
                    if (data.twofa_token) {
                        // Save token in localStorage for the verification page to use
                        localStorage.setItem("twofa_token", data.twofa_token);

                        // Redirect to 2FA verification page
                        window.location.href = "twofa_verify.php";
                    } else {
                        showError("Missing 2FA verification token");
                    }
                } else {
                    // Login error
                    showError(data.message || "An error occurred during login");
                }
            })
            .catch(error => {
                console.error("Error:", error);
                // Reset button state
                submitButton.disabled = false;
                submitButton.innerHTML = originalButtonText;
                showError("An error occurred during login. Please try again.");
            });
    });

    const recaptchaElement = document.querySelector(".g-recaptcha");
    if (recaptchaElement) {
        recaptchaElement.setAttribute("data-theme", "dark");
    }

    // Helper function to show error message
    function showError(message) {
        const errorMessageElement = document.getElementById("error-message");
        if (errorMessageElement) {
            errorMessageElement.textContent = message;
            errorMessageElement.style.display = "block";
        }
    }

    // Helper function to setup 2FA form
    function setupTwoFAVerification(token) {
        const twofaForm = document.getElementById("twofa-form");
        if (!twofaForm) return;

        const errorMessage = document.getElementById("error-message");

        twofaForm.addEventListener("submit", function (e) {
            e.preventDefault();

            const code = document.getElementById("twofa_code").value.trim();

            if (!/^\d{6}$/.test(code)) {
                if (errorMessage) {
                    errorMessage.textContent = "Please enter a valid 6-digit code";
                    errorMessage.style.display = "block";
                }
                return;
            }

            const formData = new FormData();

            // No need for CSRF token in 2FA verification, using the token instead
            formData.append("twofa_code", code);
            formData.append("twofa_token", token);

            // Show loading state
            const submitButton = twofaForm.querySelector('button[type="submit"]');
            const originalButtonText = submitButton.innerHTML;
            submitButton.disabled = true;
            submitButton.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Verifying...';

            // Send AJAX request to verify 2FA code
            fetch('./includes/login.php', {
                method: 'POST',
                body: formData
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then(data => {
                    // Reset button state
                    submitButton.disabled = false;
                    submitButton.innerHTML = originalButtonText;

                    if (data.success) {
                        // Set cookies and redirect
                        const expirationDate = new Date();
                        expirationDate.setTime(expirationDate.getTime() + (3 * 60 * 60 * 1000));
                        const currentDomain = window.location.hostname;
                        const newPath = window.location.pathname.split("/").slice(0, -1).join("/");

                        Cookies.set("user_id", data.user_id, { expires: expirationDate, path: "/" });
                        Cookies.set("username", data.username, { expires: expirationDate, path: "/" });
                        Cookies.set("name", data.name, { expires: expirationDate, path: "/" });
                        Cookies.set("avatar", data.avatar, { expires: expirationDate, path: "/" });
                        Cookies.set("domain", data.domain, { expires: expirationDate, path: "/" });
                        Cookies.set("path", newPath, { expires: expirationDate, path: "/" });
                        Cookies.set("user_type", data.user_type, { expires: expirationDate, path: "/" });

                        // Clear 2FA token
                        localStorage.removeItem("twofa_token");

                        // Redirect based on user type
                        if (data.user_type === 'owner') {
                            window.location.href = 'admin.php';
                        } else {
                            window.location.href = 'dashboard.php';
                        }
                    } else {
                        // Show error message
                        if (errorMessage) {
                            errorMessage.textContent = data.message || 'Invalid verification code';
                            errorMessage.style.display = 'block';
                        }

                        // Clear the input field
                        document.getElementById('twofa_code').value = '';
                        document.getElementById('twofa_code').focus();

                        // If the token is invalid or expired, redirect back to login
                        if (!data.requires_2fa) {
                            localStorage.removeItem("twofa_token");
                            setTimeout(() => {
                                window.location.href = 'index.php?error=' + encodeURIComponent(data.message || 'Authentication failed');
                            }, 2000);
                        }
                    }
                })
                .catch(error => {
                    console.error('Error:', error);
                    // Reset button state
                    submitButton.disabled = false;
                    submitButton.innerHTML = originalButtonText;

                    if (errorMessage) {
                        errorMessage.textContent = 'An error occurred. Please try again.';
                        errorMessage.style.display = 'block';
                    }
                });
        });
    }
});